module.exports = __webpack_public_path__ + "static/hotblack-events1-48408090e4bb777d9d8cfb9292ab698c.jpg";